<template>
  <div id="topbar">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark" style="padding-right: 30px; padding-left: 30px; ">
      <div class="container">
        <i style="font-size: 20px;" id="btvoltar" @click.prevent="mtdvoltar()" class="bi bi-chevron-double-left"></i>
        <div style="float: right ;">
          <h4>DracoMini</h4>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
/* eslint-disable */
import util from '../util';
export default {
  name: 'footernav',
  props: {

  },
  methods: {
    mtdvoltar() {
      //nas rotinas do menu

      if(    
             ($("#menusis").is(":visible")) 
          || ($("#relatoer").is(":visible")) 
          || ($("#menuperfil").is(":visible"))
      ){
        $('#relatorios').hide();
        $('#menu').hide();
        $('#perfil').hide();
        $('#dash').show();
        util.resetZoom();
        util.atzdash();
        return
      }


      $('#conteudocrud').hide();
      $('#menusis').fadeIn(700);

      //nas rotinas dos graficos/relatorios
      $('#conteudorel').hide();
      $('#relatoer').fadeIn(700);


      //nas rotinas de perfil
      $('#conteudoperfil').hide();
      $('#menuperfil').fadeIn(700);

     // this.$modal.hideAll();
      this.$modal.hide("modallancamento");
      this.$modal.hide("modaltipo");

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #333;
  padding: 10px 0;
  z-index: 10;
  /* Certifique-se de que a navbar fique acima de outros elementos */
}
</style>
